import { useEffect } from "react";
import { Globe } from "lucide-react";

// Languages prioritised for Auckland refugee & migrant communities, plus major world languages.
const INCLUDED = [
  "en", "ar", "fa", "ps", "so", "sw", "ti", "am", "my", "ne", "hi", "ur",
  "zh-CN", "zh-TW", "fr", "es", "pt", "ru", "vi", "th", "km", "tl", "id",
  "ko", "ja", "de", "it", "tr", "bn", "pa", "ta", "rw",
].join(",");

const RTL_LANGS = ["ar", "fa", "ps", "ur", "he", "sd"];

function currentTransLang() {
  const m = document.cookie.match(/googtrans=\/[^/]*\/([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "en";
}

function applyDirection() {
  const lang = currentTransLang();
  const isRtl = RTL_LANGS.includes(lang);
  document.documentElement.dir = isRtl ? "rtl" : "ltr";
}

let injected = false;

export const GoogleTranslate = () => {
  useEffect(() => {
    window.googleTranslateElementInit = () => {
      const el = document.getElementById("google_translate_element");
      if (el && el.childNodes.length) return;
      new window.google.translate.TranslateElement(
        { pageLanguage: "en", includedLanguages: INCLUDED, autoDisplay: false },
        "google_translate_element"
      );
    };

    if (!injected) {
      injected = true;
      const s = document.createElement("script");
      s.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      s.async = true;
      document.body.appendChild(s);
    } else if (window.google?.translate) {
      window.googleTranslateElementInit();
    }

    // Keep text direction in sync with the chosen language (RTL for Arabic/Dari/etc.)
    applyDirection();
    const interval = setInterval(applyDirection, 1200);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center gap-1.5 text-stone-700" data-testid="language-selector">
      <Globe className="w-4 h-4 shrink-0 text-[#2E604A]" />
      <div id="google_translate_element" />
    </div>
  );
};
